import React from 'react';
import createReactClass from 'create-react-class';
import { Link } from 'react-router-dom';
import request from '../../helpers/request';
import purchaseOrderConfig from './config/purchaseOrderConfig';
import setViewTitle from '../../helpers/setViewTitle';
import moment from 'moment';
import SimplePage from '../common/SimplePage';

const $ = window.$;

var PurchaseOrderOverview = createReactClass({

  getInitialState() {
    return {
      purchaseOrders: [],
      documentNoFilter: null,
      dateFilter: null
    };
  },

  componentWillMount() {
    setViewTitle('Genehmigte Bestellungen');
  },

  componentDidMount() {

    $('#dateFilter').datepicker({
      dateFormat: 'dd.mm.yy',
      prevText: '<i class="fa fa-chevron-left"></i>',
      nextText: '<i class="fa fa-chevron-right"></i>'
    });

    $('#dateFilter').change(e => {
      this.applyFilter(e);
    });

    this.reloadData();
  },

  reloadData() {
    request.get({
      url: purchaseOrderConfig.apiUrl,
      data: this.createFilterParams(),
      success: purchaseOrders => {
        if (this.isMounted()) {
          this.setState({
            purchaseOrders: purchaseOrders
          });
        }
      }
    });
  },

  createFilterParams() {

    var dateFilterValue = this.state.dateFilter ? moment(this.state.dateFilter, 'DD.MM.YYYY').toISOString() : null;

    return {
      documentNoFilter: this.state.documentNoFilter,
      dateFilter: dateFilterValue
    };
  },

  applyFilter(e) {
    var propName = e.target.name;
    var value = e.target.value;

    var newState = {};
    newState[propName] = value;

    this.setState(newState, () => this.reloadData());
  },

  render() {
    let orderLinks = this.state.purchaseOrders.map(order => {
      let createdString = moment(order.dateCreated).format('DD.MM.YYYY HH:mm:ss');
      let modifiedString = moment(order.dateModified).format('DD.MM.YYYY HH:mm:ss');

      return (
        <tr key={order.id}>
            <td><Link to={`/purchaseorders/${order.id}`}>{order.documentNo}</Link></td>
            <td><Link to={`/purchaseorders/${order.id}`}>{order.vendorName}</Link></td>
            <td><Link to={`/purchaseorders/${order.id}`}>{modifiedString}</Link></td>
            <td><Link to={`/purchaseorders/${order.id}`}>{createdString}</Link></td>
        </tr>
      );
    });

    return (
      <SimplePage title="Genehmigte Bestellungen" icon="truck">
        <div className="table-responsive">
          <table className="table table-bordered">
            <thead>
              <tr>
                <th>Dokument Nr</th>
                <th>Lieferant</th>
                <th>Geändert am</th>
                <th>Erstellt am</th>
              </tr>
              <tr>
                <th>
                  <input type="text" name="documentNoFilter" className="form-control" placeholder="Filter..." onChange={this.applyFilter} />
                </th>
                <th />
                <th className="icon-addon">
                  <input id="dateFilter" name="dateFilter" type="text" className="form-control" placeholder="Filter..." />
                  <label htmlFor="dateFilter" className="glyphicon glyphicon-calendar no-margin padding-top-15" rel="tooltip" title="" data-original-title="Filter Date"></label>
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {orderLinks}
            </tbody>
          </table>
        </div>
      </SimplePage>
    );
  }

});

export default PurchaseOrderOverview;



// WEBPACK FOOTER //
// ./src/components/purchaseorders/PurchaseOrderOverview.js